import Marquee from "react-fast-marquee";

const words = ["Imagine", "Describe", "Generate", "Ship", "Grow"];

export default function EditorialMarquee() {
  return (
    <section className="py-16 md:py-24 overflow-hidden" data-testid="editorial-marquee" aria-hidden="true">
      <Marquee gradient={false} speed={30} autoFill>
        {words.map((w, i) => (
          <span key={i} className="mx-10 font-editorial italic text-6xl md:text-8xl text-slate-700">
            {w} <span className="text-[#0055FF] not-italic">·</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
}
